// @ts-nocheck
import { DownCircleOutlined, MenuOutlined, RightCircleOutlined } from '@ant-design/icons';
import { withApollo } from '@apollo/client/react/hoc';
import { Divider, Table } from 'antd';
import arrayMove from 'array-move';
import React from 'react';
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import styled from 'styled-components';
import { compose } from '../../core';
import {
  AddIcon,
  DeleteIcon, displayDataCheck, EditIcon, GetColumnSearchProps, getIntFromString, getOrderBy, ReactMarkdown
} from '../../look';
import { QUESTION_SUBSCRIPTION } from '../graphql/QuestionSubscription.gql';
import { SURVEY_QUESTION_GRPOUP_SUBSCRIPTION } from '../graphql/SurveyQuestionGroupSubscription.gql';
import ROUTE from '../route';
import '../css/survey-admin-panel.css';

import QuestionTable from './QuestionTable';
import {
  withDeleteGroup, withEditGroup, withSurveyFilterUpdating, withSurveyState
} from './SurveyOperations';

const Group = props => {
  const {
    loading,
    deleteGroup,
    onNameChange,
    onLabelChange,
    onOrderByChange,
    orderBy,
    editGroup,
    SurveyById,
    me,
    client
  } = props;
  const [sequenceLoading, setSequenceLoading] = React.useState(false);
  const [allowDraggable, setAllowDraggable] = React.useState(true);
  const [dataSource, setDataSource] = React.useState([]);
  const [dragLoading, setDragLoading] = React.useState(false);
  const [pendingDragOrder, setPendingDragOrder] = React.useState(null);
  const [questionSetLoading, setQuestionSetLoading] = React.useState(false);
  const components = true;
  
  const processedDataSource = React.useMemo(() => {
    if (!dataSource) return [];
    
    if (components) {
      return dataSource;
    } else {
      return dataSource.edges && dataSource.edges.map(({ node }) => node);
    }
  }, [dataSource, components]);
  
  React.useEffect(() => {
  }, [dataSource]);

  const surveyGroupDataRef = React.useRef(null);
  const groupSubscriptionRef = React.useRef(null);
  const questionSubscriptionRef = React.useRef(null);
  const m = React.useRef(true)


  React.useEffect(() => {

    if (me) {
      SubscribeToGroup();
      SubscribeToQuestion();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me])


  React.useEffect(() => {
    return () => {
      m.current = false
    }
  }, [])

  React.useEffect(() => {
    m.current = true

  }, [])


  React.useEffect(() => {
    return () => {
      if (groupSubscriptionRef.current) {
        groupSubscriptionRef.current.unsubscribe();
        groupSubscriptionRef.current = null;
      }
      if (questionSubscriptionRef.current) {
        questionSubscriptionRef.current.unsubscribe();
        questionSubscriptionRef.current = null;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  const SubscribeToGroup = () => {
    groupSubscriptionRef.current = client.subscribe({
      query: SURVEY_QUESTION_GRPOUP_SUBSCRIPTION,
    }).subscribe({
      next(result) {
        switch (result.data.surveyQuestionGroupSubscription.mutation) {

          case 'DELETE':
            if (m.current) {
              let groupSet;
              groupSet = surveyGroupDataRef?.current;
              let groupSetWithDeletedRecord = groupSet?.filter((group) =>
                group?.id !== result.data.surveyQuestionGroupSubscription?.group?.id
              )
              setDataSource(groupSetWithDeletedRecord);
              surveyGroupDataRef.current = groupSetWithDeletedRecord;
            }
            break;
          case 'UPDATE':
            if (m.current) {
              const updatedGroup = result.data.surveyQuestionGroupSubscription?.group;
              setDataSource(currentDataSource => {
                const groupIndex = currentDataSource?.findIndex((group) => group?.id === updatedGroup.id);
                if (groupIndex >= 0) {
                  const currentGroup = currentDataSource[groupIndex];
                  const hasChanged = JSON.stringify(currentGroup) !== JSON.stringify({ ...currentGroup, ...updatedGroup });
                  if (hasChanged) {
                    const newDataSource = [...currentDataSource];
                    newDataSource[groupIndex] = { ...newDataSource[groupIndex], ...updatedGroup };
                    surveyGroupDataRef.current = newDataSource;
                    // Check if this update matches our pending drag order
                    if (dragLoading && pendingDragOrder) {
                      const currentOrder = newDataSource.map(item => item.id);
                      const orderMatches = JSON.stringify(currentOrder) === JSON.stringify(pendingDragOrder);
                      if (orderMatches) {
                        setDragLoading(false);
                        setPendingDragOrder(null);
                      }
                    }
                    return newDataSource;
                  } else {
                    return currentDataSource;
                  }
                }
                return currentDataSource;
              });
            }
            break;
          default:
            break
        }

      }
    })

  }

  const SubscribeToQuestion = () => {
    questionSubscriptionRef.current = client.subscribe({
      query: QUESTION_SUBSCRIPTION,
    }).subscribe({
      next(result) {
        switch (result.data.surveyQuestionSubscription.mutation) {

          case 'DELETE':
            if (m.current) {
              setQuestionSetLoading(true);
              let indexOfUpdatedGroup = surveyGroupDataRef?.current.findIndex((value) => value?.node?.id === result.data.surveyQuestionSubscription?.id)
              if (indexOfUpdatedGroup >= 0) {
                let updatedGroup = surveyGroupDataRef?.current[indexOfUpdatedGroup];

                let groupWithDeletedQuestion = updatedGroup?.questionSet?.edges?.filter((question) =>
                  question?.node?.id !== result.data.surveyQuestionSubscription?.question?.id
                )

                updatedGroup.questionSet = { edgeCount: (surveyGroupDataRef?.current[indexOfUpdatedGroup]?.questionSet?.edgeCount - 1), totalCount: (surveyGroupDataRef?.current[indexOfUpdatedGroup]?.questionSet?.totalCount - 1), edges: groupWithDeletedQuestion };

                surveyGroupDataRef.current[indexOfUpdatedGroup] = updatedGroup;

                setDataSource(surveyGroupDataRef?.current);
                setTimeout(() => setQuestionSetLoading(false), 500);
              }

            }
            break;
          case 'UPDATE':
            if (m.current) {
              setQuestionSetLoading(true);
              const updatedQuestion = result.data.surveyQuestionSubscription?.question;
              
              setDataSource(currentDataSource => {
                for (let i = 0; i < currentDataSource?.length; i++) {
                  const group = currentDataSource[i];
                  const questionIndex = group?.questionSet?.edges?.findIndex(
                    (q) => q?.node?.id === updatedQuestion.id
                  );
                  
                  if (questionIndex >= 0) {
                    const newDataSource = [...currentDataSource];
                    newDataSource[i] = { ...newDataSource[i] };
                    newDataSource[i].questionSet = { ...newDataSource[i].questionSet };
                    newDataSource[i].questionSet.edges = [...newDataSource[i].questionSet.edges];
                    newDataSource[i].questionSet.edges[questionIndex] = { node: updatedQuestion };
                    
                    newDataSource[i].questionSet.edges.sort((a, b) => 
                      (a.node.sequence < b.node.sequence ? -1 : a.node.sequence > b.node.sequence ? 1 : 0)
                    );
                    
                    if (updatedQuestion.choiceSet && updatedQuestion.choiceSet.edges) {
                      const updatedChoiceSet = {
                        ...updatedQuestion.choiceSet,
                        edges: [...updatedQuestion.choiceSet.edges].sort((a, b) => 
                          (a.node.sequence < b.node.sequence ? -1 : a.node.sequence > b.node.sequence ? 1 : 0)
                        )
                      };
                      const newQuestionIndex = newDataSource[i].questionSet.edges.findIndex(
                        (q) => q?.node?.id === updatedQuestion.id
                      );
                      if (newQuestionIndex >= 0) {
                        newDataSource[i].questionSet.edges[newQuestionIndex] = { 
                          node: { ...updatedQuestion, choiceSet: updatedChoiceSet } 
                        };
                      }
                    }
                    
                    surveyGroupDataRef.current = newDataSource;
                    setTimeout(() => setQuestionSetLoading(false), 500);
                    return newDataSource;
                  }
                }
                setTimeout(() => setQuestionSetLoading(false), 500);
                return currentDataSource;
              });
            }
            break;
          default:
            break
        }

      }
    })

  }

  React.useEffect(() => {
    if (components) {
      const edges = [];
      SurveyById?.groupSet &&
        SurveyById.groupSet.edges.length > 0 &&
        // eslint-disable-next-line array-callback-return
        SurveyById.groupSet.edges.map(({ node }, index) => {
          // De-duplicate questions by id
          let questionEdges = node.questionSet?.edges || [];
          const seenIds = new Set();
          const uniqueEdges = questionEdges.filter(edge => {
            if (seenIds.has(edge.node.id)) return false;
            seenIds.add(edge.node.id);
            return true;
          });
          // Sort questions by sequence within each group
          const sortedQuestionSet = {
            ...node.questionSet,
            edges: uniqueEdges.sort((a, b) => a.node.sequence - b.node.sequence)
          };
          edges.push({ ...node, questionSet: sortedQuestionSet, index: index + 1 });
        });
      // Sort groups by sequence
      const sortedEdges = edges.sort((a, b) => a.sequence - b.sequence);
      surveyGroupDataRef.current = sortedEdges;
      setDataSource(sortedEdges);
    } else {
      surveyGroupDataRef.current = SurveyById;
      setDataSource(SurveyById);
    }
  }, [components, SurveyById]);

  const handleDelete = async id => {
    setSequenceLoading(true);
    try {
      await deleteGroup({ id: id });
    } catch (e) {
      throw new Error(e.message);
    }
    setSequenceLoading(false);
  };

  const onSort = async sortedItems => {
    setSequenceLoading(true);
    try {
      await Promise.all(
        sortedItems.map(async i => {
          // const response = await
          editGroup({ id: getIntFromString(i.id), name: i.name, sequence: i.index + 1 });
        })
      );
      setSequenceLoading(false);
    } catch (e) {
      setSequenceLoading(false);
      throw Error(e.message);
    }
  };

  const DragHandle = sortableHandle(() => (
    <MenuOutlined style={{ cursor: 'grab', color: '#999', margin: '-16px', padding: '16px', width: '100%' }} />
  ));

  const columns = [
    {
      title: 'Sort',
      dataIndex: 'sort',
      width: '6%',
      className: 'drag-visible',
      render: () => <DragHandle />
    },
    {
      title: 'Name',
      key: 'name',
      className: 'drag-visible',
      sorter: () => onOrderByChange(getOrderBy('name', orderBy)),
      ...GetColumnSearchProps('name', onNameChange),
      render: (text, record) => record && <div>{displayDataCheck(record.name)}</div>
    },
    {
      title: 'Label',
      key: 'label',
      sorter: () => onOrderByChange(getOrderBy('label', orderBy)),
      ...GetColumnSearchProps('label', onLabelChange),
      render: (text, record) => record && <div><ReactMarkdown style={{ margin: '0.5em 0' }}>{displayDataCheck(record.label)}</ReactMarkdown></div>
    },
    {
      title: 'Link',
      key: 'link',
      align: 'right',
      render: (text, record) => (
        <div style={{ width: '30px' }}>
          <AddIcon
            type="link"
            size="md"
            tooltipSuffix="Question"
            /* target="_blank" */ href={`${ROUTE.addQuestionLink}${getIntFromString(record.id)}`}
          />
          <Divider type="vertical" />
          <EditIcon
            type="link"
            tooltipSuffix="Group"
            size="md"
            /* target="_blank" */ href={`${ROUTE.editGroupLink}${getIntFromString(record.id)}`}
          />
          <Divider type="vertical" />
          <DeleteIcon size="md" tooltipSuffix="Group" onClick={() => handleDelete(getIntFromString(record.id))} />
        </div>
      )
    }
  ];

  const rowKey = 'index';
  const SortableItem = sortableElement(props => <tr {...props} />);
  const SortableContainer = sortableContainer(props => <tbody {...props} />);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const newData = arrayMove([].concat(dataSource), oldIndex, newIndex).filter(el => !!el);
      const indexData = [];
      // eslint-disable-next-line array-callback-return
      newData.map((node, index) => {
        const data = newData[index];
        indexData.push({ ...data, index: index });
      });
      // Only update state if the order actually changed
      const currentOrder = dataSource.map(item => item.id);
      const newOrder = indexData.map(item => item.id);
      const orderChanged = JSON.stringify(currentOrder) !== JSON.stringify(newOrder);
      if (orderChanged) {
        // Start drag loading and store pending order
        setDragLoading(true);
        setPendingDragOrder(newOrder);
        setDataSource(indexData);
        onSort && onSort(indexData);
        // Fallback timeout to stop loading after 10 seconds if no subscription update
        setTimeout(() => {
          setDragLoading(false);
          setPendingDragOrder(null);
        }, 10000);
      } else {
      }
    } else {
    }
  };

  const DraggableContainer = props => (
    <SortableContainer useDragHandle disableAutoscroll helperClass="row-dragging-group" onSortEnd={onSortEnd} {...props} />
  );

  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    const index = dataSource && dataSource.findIndex(x => x.index === restProps['data-row-key']);
    return <SortableItem style={{ border: "1px solid #f5f5f5", borderRadius: '5px', width: "100%", justifyContent: "space-between" }} index={index} {...restProps} />;
  };

  const dragable = allowDraggable
    ? {
      components: {
        body: {
          wrapper: DraggableContainer,
          row: DraggableBodyRow
        }
      }
    }
    : {};

  return (
    <>
      <MyTable
        className="survey-group-table"
        size={!(SurveyById && SurveyById.groupSet && SurveyById && SurveyById.groupSet.totalCount) && 'middle'}
        loading={loading || sequenceLoading || dragLoading}
        rowKey={record => (rowKey === 'id' ? getIntFromString(record[rowKey]) : record[rowKey])}
        showHeader={false}
        dataSource={processedDataSource}
        columns={columns.map(c => ({ ...c, sortDirections: ['descend', 'ascend', 'descend'] }))}
        expandable={{
          expandedRowRender: (record, index, indent, expanded) => (
            <QuestionTable
              record={record}
              index={index}
              indent={indent}
              expanded={expanded}
              setSequenceLoading={setSequenceLoading}
              questionSetLoading={questionSetLoading}
            />
          ),
          expandIcon: ({ expanded, onExpand, record }) =>
            record.questionSet.edgeCount !== 0 ? (
              expanded ? (
                <DownCircleOutlined
                  onClick={e => {
                    setAllowDraggable(true);
                    onExpand(record, e);
                  }}
                  style={{ fontSize: 18, display: 'flex', alignSelf: 'center', color: '#CACACA', width: '100%' }}
                />
              ) : (
                <RightCircleOutlined
                  onClick={e => {
                    setAllowDraggable(false);
                    onExpand(record, e);
                  }}
                  style={{ fontSize: 18, display: 'flex', alignSelf: 'center', color: '#CACACA', width: '100%' }}
                />
              )
            ) : null
        }}
        {...dragable}
      />
    </>
  );
};

export default compose(withSurveyState, withDeleteGroup, withEditGroup, withSurveyFilterUpdating, withApollo)(React.memo(Group));

export const MyTable = styled(Table)`
  &.survey-group-table table {
    border-collapse: separate !important;
    border-spacing: 0 4px !important;
    
    .ant-table-row-expand-icon-cell {
      width: 6% !important;
      min-width: 6% !important;
      max-width: 6% !important;
    }
    
    > tbody > tr:not(.ant-table-expanded-row) {
      border: none !important;
      > td:not([colspan]) {
        background-color: white !important;
        border-top: 1px solid rgba(0, 0, 0, 0.06) !important;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
      }
      > td:not([colspan]):first-child {
        border-left: 1px solid rgba(0, 0, 0, 0.06) !important;
        border-top-left-radius: 5px !important;
        border-bottom-left-radius: 5px !important;
      }
      > td:not([colspan]):last-child {
        border-right: 1px solid rgba(0, 0, 0, 0.06) !important;
        border-top-right-radius: 5px !important;
        border-bottom-right-radius: 5px !important;
      }
    }
    
    /* Exclude nested tables from getting borders */
    .ant-table-expanded-row table,
    .ant-table-expanded-row table td {
      border: none !important;
      border-radius: 0 !important;
    }
    
    /* Exclude td elements that contain tr elements from getting borders */
    > tbody > tr > td:has(tr) {
      border: none !important;
      border-radius: 0 !important;
      background-color: transparent !important;
    }
  }
`;


